import { switchMapTo } from 'rxjs/operators'

import turbolinksLoadedObservable from '@newswebsiteapp/shared/observables/turbolinksLoadedObservable'
import nightmodeSubject from './subject'

turbolinksLoadedObservable.pipe(switchMapTo(nightmodeSubject)).subscribe({
  next: (v) => {
    if (v === true) {
      switchToNight()
    } else {
      switchToDay()
    }
  },
})

function switchToNight() {
  $('body').addClass('nightmode')

  // console.log($("[data-hidden-when-day]"))
  // console.log($("[data-hidden-when-night]"))

  $('[data-hidden-when-day]').removeClass('hidden')
  $('[data-hidden-when-night]').addClass('hidden')
}

function switchToDay() {
  $('body').removeClass('nightmode')

  // console.log($("[data-hidden-when-day]"))
  // console.log($("[data-hidden-when-night]"))

  $('[data-hidden-when-day]').addClass('hidden')
  $('[data-hidden-when-night]').removeClass('hidden')
}
